<template>
	<ClientOnly>
		<div class="login-register">
			<div class="wider-wrapper lr-wrapper">
				<div class="lr-cols">
					<div class="lr-col1">
						<slot name="col1" />
					</div>
					<div class="lr-col2">
						<slot name="col2" />
					</div>
				</div>
			</div>
		</div>
		<template #fallback>
			<BaseThemeUiLoading />
		</template>
	</ClientOnly>
</template>